import actionCreatorFactory from "typescript-fsa";
import { MaintenanceInfo } from "../app";

const actionCreator = actionCreatorFactory("@@Asset");

export const assetActions = {
  fetchMessages: actionCreator.async<{}, {}>("FETCH_MESSAGES"),
  fetchSettings: actionCreator.async<{}, { showSms: boolean }>("FETCH_SETTINGS"),
  fetchMaintenance: actionCreator.async<{}, MaintenanceInfo>("FETCH_MAINTENANCE"),
  fetchStockItemJson: actionCreator.async<{}, { messageText: string }>("FETCH_STOCK_ITEM_JSON"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
